import { Container, ContainerPadding, Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { PortalContext } from '../../../../../context/PortalContext';
import { HuchaValues } from '../../models/hucha-values';
import { HuchaBonusPopup } from './hucha-bonus-popup';
import { RenovadoresBonusPopup } from './renovadores-bonus-popup';

export const HuchaPopupContent = ({
	huchaValues,
	portalContext,
	handlePopupClose,
}: {
	huchaValues: HuchaValues | null;
	portalContext: any;
	handlePopupClose: () => void;
}) => {
	const layerContent = () => {
		if (huchaValues?.isRenovador) {
			return <RenovadoresBonusPopup huchaValues={huchaValues} />;
		} else {
			return <HuchaBonusPopup huchaValues={huchaValues} />;
		}
	};

	return (
		<PortalContext.Provider value={portalContext}>
			<Container
				horizontalAlign={'flex-end'}
				padding={{
					top: ContainerPadding.dynamic0100,
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b1600]: ContainerPadding.dynamic0100,
					},
					bottom: ContainerPadding.dynamic0100,
				}}
			>
				<CTA
					tag="button"
					emphasis="tertiary"
					onClick={handlePopupClose}
					aria-label="Close pop-up"
					icon={<Close variant="default" aria-hidden />}
				/>
			</Container>
			{layerContent()}
		</PortalContext.Provider>
	);
};
